export const en = {
  // Navbar
  nav: {
    foundationSession: "Foundation Session",
    testimonials: "Testimonials",
    services: "Services",
    blog: "Blog",
    aboutDr: "About Dr. Shimaa",
    contact: "Contact",
    bookSession: "Book Session",
    bookSessionChange: "Book Your Session",
    logoName: "Dr. Shimaa Anwer",
    logoTitle: "Professor of Public Health & Preventive Medicine • Clinical Nutrition & Lifestyle Medicine Consultant",
    openMenu: "Open menu",
    closeMenu: "Close menu",
    mainNav: "Main navigation",
  },

  // Hero
  hero: {
    trustBadge: "Verified Account • 500+ Successful Transformations",
    headlinePre: "Weight loss is now ",
    headlineHighlight: "easier",
    headlinePost: " with a healthy diet that starts from your mindset",
    description: "Clinical Nutrition Specialist — Dr. Shimaa Anwer. We design a personalized, complete daily healthy meal plan — not just a diet. Join clients across the Middle East and worldwide and get lasting results.",
    spotsLeft: "Only 3 spots left today",
    ctaBook: "Book Your Transformation Session",
    ctaWhatsApp: "Chat on WhatsApp",
    socialProof: "500+ clients",
    socialProofSuffix: " worldwide • ⭐ 4.9/5",
    sectionLabel: "Hero section",
    playVideo: "Play Dr. Shimaa Anwer's video",
    heroImageAlt: "Clinical Nutrition Specialist — Dr. Shimaa Anwer — Healthy diet plan and daily schedule",
    whatsAppMessage: "Hello Dr. Shimaa, I'd like to learn more about your clinical nutrition programs",
  },

  // Hero Testimonials
  heroTestimonials: {
    sectionLabel: "Client Results",
    heading: "Real Results from Real Clients",
    items: [
      { name: "Sara Ahmed", role: "Marketing Manager", quote: "Lost 15 kg in 3 months and my energy skyrocketed", stat: "-15 kg", statLabel: "in 3 months" },
      { name: "Mohamed Khaled", role: "Entrepreneur", quote: "My productivity and focus are better than ever", stat: "+80%", statLabel: "energy increase" },
      { name: "Nourhan Mahmoud", role: "Mother of 3", quote: "Finally found a system that works for the whole family", stat: "-12 kg", statLabel: "no deprivation" },
    ],
  },

  // Video Section
  video: {
    tag: "Mental & Physical Health",
    heading: "True Balance Between Your Mental & Physical Health",
    description: "Subscribe to our channel and join the family — practical tips on clinical nutrition and lifestyle medicine",
    playLabel: "Play Dr. Shimaa Anwer's video",
    thumbnailAlt: "Dr. Shimaa Anwer video thumbnail",
  },

  // Stats
  stats: {
    sectionLabel: "Statistics",
    items: [
      { value: "500+", label: "Successful Clients", description: "Achieved their health goals" },
      { value: "92%", label: "Success Rate", description: "Sustained results after one year" },
      { value: "10+", label: "Years of Experience", description: "In clinical nutrition" },
      { value: "4.9/5", label: "Client Rating", description: "Complete satisfaction" },
    ],
  },

  // Therapeutic Nutrition
  therapeuticNutrition: {
    tag: "Clinical Nutrition",
    heading: "What is Clinical Nutrition?",
    description: "Clinical nutrition is a specialized branch of medicine provided by a clinical nutrition specialist, using food as a therapeutic tool to design a healthy diet and a complete daily meal plan for treating chronic diseases like diabetes and hypertension — not just a weight-loss diet.",
    entities: [
      "Diabetes & Blood Pressure Management",
      "Gut Microbiome Health",
      "Stress & Anxiety Reduction",
      "Insulin Resistance Improvement",
      "Obesity Treatment",
      "Chronic Disease Prevention",
    ],
    citation: ", specialized clinical nutrition reduces chronic disease complications by up to 70%.",
    citationPrefix: "According to",
    citationAnd: "and",
    entitiesLabel: "Clinical Nutrition Areas",
  },

  // Philosophy
  philosophy: {
    tag: "Lifestyle Medicine",
    heading: "The Six Pillars of Holistic Health",
    description: "Lifestyle Medicine — endorsed by the",
    aclmName: "American College of Lifestyle Medicine (ACLM)",
    descMiddle: "— focuses on six key pillars that impact your health: Nutrition, Movement, Sleep, Stress Management, Supportive Relationships, and Eliminating Harmful Habits. According to",
    whoName: "World Health Organization",
    descEnd: " recommendations, lifestyle changes prevent over 80% of chronic diseases.",
    pillars: [
      { title: "Nutrition", description: "Personalized nutrition strategies tailored to your body, lifestyle, and goals. Sustainable, science-backed eating systems." },
      { title: "Movement", description: "Functional fitness programs that complement your health journey. Build strength, improve mobility, and boost daily performance." },
      { title: "Sleep", description: "Improve your sleep quality to restore energy and enhance physical and mental health." },
      { title: "Stress Management", description: "Effective techniques for handling daily life pressures and achieving psychological balance." },
      { title: "Supportive Relationships", description: "Building a strong social support network to help you stay on track in your health journey." },
      { title: "Eliminating Harmful Habits", description: "Strategies to let go of damaging behaviors and replace them with sustainable healthy habits." },
    ],
  },

  // Testimonials
  testimonials: {
    tag: "Success Stories",
    heading: "Real Transformations, Real People",
    prevLabel: "Previous testimonial",
    nextLabel: "Next testimonial",
    goToLabel: "Go to testimonial",
    items: [
      { name: "Sara Ahmed", role: "Marketing Manager", quote: "Working with this coach completely changed my relationship with food. I lost 15 kg and my energy went through the roof. The mindset work was a game changer." },
      { name: "Mohamed Khaled", role: "Tech Entrepreneur", quote: "As a busy business person, I needed something sustainable. The Elite program fits me perfectly. My productivity and focus are better than ever." },
      { name: "Nourhan Mahmoud", role: "Working Mom of 3", quote: "I finally found a system that works for the whole family. The recipes are delicious and the support is amazing. This isn't a diet — it's a lifestyle." },
      { name: "Ahmed Adel", role: "Former Athlete", quote: "After years of yo-yo dieting, I finally understood my body. The scientific approach helped me regain my athletic performance and confidence." },
    ],
  },

  // Author Block
  author: {
    tag: "The Treating Physician",
    heading: "Dr. Shimaa Anwer",
    bio: "Professor of Public Health at the Faculty of Medicine and Clinical Nutrition & Lifestyle Medicine Consultant. Creator of the first Arabic program combining mindset transformation with evidence-based clinical nutrition.",
    imageAlt: "Dr. Shimaa Anwer — Clinical Nutrition Consultant & Public Health Professor",
    credentials: [
      { title: "Public Health Professor", detail: "Faculty of Medicine — Accredited University" },
      { title: "Clinical Nutrition Consultant", detail: "Specialized in clinical nutrition & chronic diseases" },
      { title: "ACLM Certified", detail: "American College of Lifestyle Medicine" },
      { title: "Researcher & Lecturer", detail: "Published research in clinical nutrition & lifestyle medicine" },
    ],
    specializationsTitle: "Specializations & Expertise",
    specializations: [
      "Clinical Nutrition for Chronic Diseases",
      "Type 2 Diabetes Management",
      "Gut Health & Microbiome",
      "Obesity & Insulin Resistance",
      "Lifestyle Medicine & Mindset Coaching",
      "Women's Nutrition & Supplements",
    ],
    hashtag: "#Remember_You_Are_Not_Alone",
    specializationsLabel: "Dr. Shimaa Anwer's Specializations",
  },

  // Foundation Session
  foundation: {
    badge: "Recommended First Step",
    heading: "Start Your Journey with Dr. Shimaa",
    headingHighlight: " with a Foundation Session",
    subtitle: "40 minutes to discover if you're truly ready to start your transformation journey — only for",
    price: "500 EGP",
    ctaTop: "Start Now for 500 EGP",
    badgeCard: "Perfect for First Session",
    cardTitle: "Foundation Session — 40 Minutes",
    duration: "40 minutes",
    priceValue: "500",
    priceCurrency: "EGP",
    priceNote: "A small investment before any long-term commitment",
    bullets: [
      "Identify where you are now and the real challenges in your life and health",
      "Paint a clear picture of the version of yourself you want to become",
      "Discover if you're truly ready for the full transformation journey",
    ],
    note: "This session is the first step before choosing any full package",
    ctaCard: "Book Foundation Session",
    reassurance: "Quick session, small investment, before committing to any package",
    detailTitle: "What happens in the session?",
    detailDesc: "This session is the \"foundation stone\" we'll build everything on. In 40 minutes, my goal is to listen with a coach's heart and a doctor's mind to determine:",
    step1Title: "Where are we now?",
    step1Desc: "We'll identify the real challenges that are holding back your life or affecting your health.",
    step2Title: "Where do we want to go?",
    step2Desc: "We'll paint a clear, specific picture of the version of yourself you wish to become regarding your health and social life.",
    quoteTitle: "A Word from the Heart Before We Start",
    quote1: "Because change is a journey that requires patience and mutual effort, this session's main goal is to identify clients who are truly ready for the challenge of change.",
    quote2: "Not everyone is ready at this moment for the demands of this journey, and that's perfectly their right.",
    quote3: "That's why I choose clients who have genuine determination to change, to ensure our time and effort together lead to real results and a successful investment.",
    hashtag: "#Remember_You_Are_Not_Alone",
    sessionLabel: "Foundation Session — 40 Minutes",
    sessionLabelShort: "Foundation Session — 40 min • 500 EGP",
  },

  // Services
  services: {
    tag: "Choose Your Package",
    heading: "Packages Designed for Your Success",
    description: "Every package includes a complete daily healthy meal plan + a 100% personalized diet tailored to your needs. Choose what fits your goals.",
    offerEnds: "Offer ends in",
    day: "day",
    hour: "hour",
    minute: "min",
    second: "sec",
    discount: "🔥 Extra 30% off — limited time only",
    foundationNote: "💡 We recommend booking a",
    foundationLink: "Foundation Session",
    foundationNoteSuffix: " first to determine your readiness and the best package for you.",
    mostPopular: "Most Popular",
    startNow: "Get Started",
    suggestedStep: "Recommended step before this package:",
    foundationPrice: "Foundation Session for 500 EGP",
    packages: [
      {
        name: "Starter",
        originalPrice: "5,000 EGP",
        price: "3,500 EGP",
        duration: "4 weeks",
        description: "A strong start to break bad habits and build a healthy foundation.",
        features: ["Comprehensive health assessment", "Personalized meal plan", "Weekly 30-min coaching call", "Email support", "Healthy recipe collection"],
      },
      {
        name: "Transformation",
        originalPrice: "12,857 EGP",
        price: "9,000 EGP",
        duration: "12 weeks",
        description: "A comprehensive program to change your lifestyle with lasting results.",
        features: ["In-depth metabolic analysis", "Personal nutrition protocol", "Weekly 60-min coaching call", "Movement program", "Mindset coaching sessions", "Priority WhatsApp support", "Progress tracking"],
      },
      {
        name: "Elite",
        originalPrice: "35,714 EGP",
        price: "25,000 EGP",
        duration: "6 months",
        description: "VIP support for executives and high performers seeking optimal health.",
        features: ["All Transformation features", "90-min sessions biweekly", "24/7 direct communication", "Quarterly lab review", "Work stress management", "Travel nutrition plan", "Family nutrition guidance"],
      },
    ],
  },

  // Urgency Banner
  urgency: {
    heading: "Limited Spots This Month",
    description: "Book your transformation session at a special price — only 3 spots left",
    cta: "Book Your Transformation Now",
  },

  // FAQ
  faq: {
    tag: "FAQ",
    heading: "Got Questions? We've Got Answers",
    items: [
      { question: "What is clinical nutrition and how does it differ from a regular diet?", answer: "Clinical nutrition uses food as a medical tool to treat conditions like diabetes and hypertension — it's not just a weight-loss diet. A specialized clinical nutritionist designs a healthy diet plan based on your lab results and health condition for lasting results." },
      { question: "Do you provide a complete daily healthy meal plan?", answer: "Yes, every program includes a complete daily healthy meal plan tailored to your condition — including main meals, snacks, and nutrient distribution. Suitable for diabetes, hypertension, overweight, and gut issues." },
      { question: "How does the follow-up work?", answer: "Weekly coaching calls (30–90 minutes depending on package) + daily WhatsApp support + continuous progress monitoring with plan adjustments based on your results. The program is fully online and travel-friendly." },
      { question: "How soon can I see results?", answer: "Week 1: improved energy and sleep. Weeks 3–4: visible physical results. 8–12 weeks: complete lifestyle transformation. Results vary based on commitment and health condition." },
      { question: "What are the package prices in Gulf currencies?", answer: "Starter: 3,500 EGP (≈260 SAR). Transformation: 9,000 EGP (≈670 SAR). Elite: 25,000 EGP (≈1,860 SAR). Payment in Egyptian Pounds; prices are approximate based on exchange rates." },
    ],
  },

  // Lead Magnet
  leadMagnet: {
    heading: "Free: 7-Day Vitality Guide",
    description: "Start your transformation with my proven system. You'll receive daily practical tips on nutrition, movement, and mindset straight to your inbox.",
    placeholder: "Enter your email",
    cta: "Get the Free Guide",
    processing: "Processing...",
    socialLine: "Join 5,000+ people on their vitality journey. Unsubscribe anytime.",
    errorTitle: "Invalid Email",
    errorDesc: "Please enter a valid email address.",
    alreadyTitle: "Already Registered!",
    alreadyDesc: "You're already on our list. Check your inbox.",
    successTitle: "Welcome to the Journey!",
    successDesc: "You'll find the 7-Day Vitality Guide in your inbox.",
    failTitle: "Something went wrong",
    failDesc: "Couldn't register your email. Please try again.",
  },

  // Contact
  contact: {
    tag: "Contact Me",
    heading: "Ready to Start Your Transformation?",
    description: "Whether you have questions about the programs or you're ready to take the first step, I'd love to hear from you. Let's see how we can work together.",
    emailLabel: "Email",
    phoneLabel: "Phone",
    locationLabel: "Location",
    locationValue: "Cairo, Egypt (Available Online)",
    nameLabel: "Full Name",
    namePlaceholder: "Your name",
    emailPlaceholder: "email@example.com",
    messageLabel: "Message",
    messagePlaceholder: "Tell me about your goals and how I can help...",
    submit: "Send Message",
    processing: "Processing...",
    errorTitle: "Data Error",
    successTitle: "Message Sent!",
    successDesc: "Thank you for reaching out. I'll respond within 24 hours.",
    failTitle: "Something went wrong",
    failDesc: "Couldn't send the message. Please try again.",
  },

  // Footer
  footer: {
    copyright: "© {year} Vitality Coaching. All rights reserved.",
    madeWithLove: "Made with love for your health",
    trustedSources: "Trusted sources:",
    servicesTitle: "Our Services",
    resourcesTitle: "Resources",
    legalTitle: "Legal",
    services: {
      foundationSession: "Foundation Session",
      starter: "Starter",
      transformation: "Transformation",
      elite: "Elite",
    },
    resources: {
      freeGuide: "Free Vitality Guide",
      blog: "Blog",
      aboutDr: "About Dr. Shimaa",
      services: "Services",
    },
    legal: {
      privacy: "Privacy Policy",
    },
  },

  // Social Proof Toast
  socialProof: {
    close: "Close",
    suffix: "500+ successful transformations worldwide",
    items: [
      { name: "Sara M.", location: "Riyadh 🇸🇦", text: "Lost 15 kg in 3 months" },
      { name: "Ahmed K.", location: "Dubai 🇦🇪", text: "My life completely changed" },
      { name: "Noura A.", location: "Jeddah 🇸🇦", text: "Best decision I made for my health" },
      { name: "Mohamed R.", location: "Abu Dhabi 🇦🇪", text: "Amazing results from the first month" },
      { name: "Fatima A.", location: "Dammam 🇸🇦", text: "My energy and mood improved so much" },
    ],
  },

  // Exit Intent Popup
  exitPopup: {
    heading: "Wait! You Have a Gift 🎁",
    description: "Before you go, download the",
    guideName: "7-Day Vitality Guide",
    descriptionSuffix: " for free — daily practical tips for nutrition and energy.",
    placeholder: "Enter your email here",
    cta: "Download Free Guide",
    processing: "Processing...",
    trustLine: "🔒 Your email is safe. No spam. Unsubscribe anytime.",
    noThanks: "No thanks, I'm good",
    ariaLabel: "Special offer before you leave",
    close: "Close",
  },

  // Sticky Mobile CTA
  stickyCta: {
    text: "Book Your Session Now",
  },

  // Booking Modal
  booking: {
    chooseDate: "Choose Your Preferred Date",
    chooseTime: "Choose Time",
    spotsLeft: "Only 3 spots left today",
    next: "Next",
    contactInfo: "Contact Information",
    nameLabel: "Name",
    namePlaceholder: "Enter your name",
    whatsappLabel: "WhatsApp Number",
    emailLabel: "Email",
    emailNote: "To send your booking confirmation",
    confirmNote: "Your booking will be confirmed via WhatsApp immediately",
    back: "Back",
    confirmWhatsApp: "Confirm Booking via WhatsApp",
    processing: "Processing...",
    successTitle: "Booking Request Sent Successfully!",
    successDesc: "You'll be contacted via WhatsApp to confirm your appointment",
    foundationSuccessDesc: "Dr. Shimaa's team will contact you to confirm the final appointment shortly",
    errorTitle: "Error Occurred",
    errorDesc: "Please try again or contact us via WhatsApp",
    nameError: "Please enter a valid name (at least 2 characters)",
    phoneError: "Phone number must be {n} digits",
    emailError: "Please enter a valid email",
    foundationLabel: "Foundation Session — 40 Minutes",
    generalLabel: "Nutrition Consultation",
    foundationBadge: "Foundation Session — 40 min • 500 EGP",
    whatsAppConfirmMsg: "Hello, I booked a session and want to confirm the appointment",
    whatsAppConfirmFoundation: "Hello, I booked a Foundation Session and want to confirm the appointment",
    days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    successCardTitle: "Booking Request Sent!",
    whatsappConfirmBtn: "Confirm via WhatsApp",
    close: "Close",
  },

  // WhatsApp
  whatsapp: {
    label: "Chat on WhatsApp",
    message: "Hello Dr. Shimaa, I'd like to learn more about your clinical nutrition programs",
  },
} as const;
